import { render, staticRenderFns } from "./type-list.vue?vue&type=template&id=53518ae8&"
import script from "./type-list.vue?vue&type=script&lang=ts&"
export * from "./type-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports